import { Routes } from '@angular/router';
import { StudyEditorComponent } from './study-editor.component';
import { StudySettingsComponent } from './tabs/study-settings/study-settings.component';
import { GermplasmChecksComponent } from './tabs/germplasm-checks/germplasm-checks.component';
import { TreatmentFactorsComponent } from './tabs/treatment-factors/treatment-factors.component';
import { StudyEnvironmentsComponent } from './tabs/study-environments/study-environments.component';
import { StudyDatasetComponent } from './tabs/dataset/study-dataset.component';
import { ExperimentalDesignComponent } from './tabs/experimental-design/experimental-design.component';
import { CrossesAndSelectionsComponent } from './tabs/crosses-and-selections/crosses-and-selections.component';
import { InventoryComponent } from './tabs/inventory/inventory.component';
import { SummaryStatisticsComponent } from './tabs/summary-statistics/summary-statistics.component';
import { SampleListComponent } from './tabs/sample-list/sample-list.component';
import { SampleGenotypeComponent } from './tabs/sample-genotype/sample-genotype.component';

export const STUDY_EDITOR_ROUTES: Routes = [
    {

        path: ':studyId',  // Remove 'study-editor/' from here since it's now handled by lazy loading
        component: StudyEditorComponent,
        children: [
            {
                path: 'study-settings',
                component: StudySettingsComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.study-settings'
                }
            },
            {
                path: 'germplasm-and-checks',
                component: GermplasmChecksComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.germplasm-and-checks'
                }
            },
            {
                path: 'treatment-factors',
                component: TreatmentFactorsComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.treatment-factors'
                }
            },
            {
                path: 'environments',
                component: StudyEnvironmentsComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.environments'
                }
            },
            {
                path: 'experimental-design',
                component: ExperimentalDesignComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.experimental-design'
                }
            },
            {
                path: 'study-dataset/:datasetId',
                component: StudyDatasetComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.study-dataset'
                }
            },
            {
                path: 'crosses-and-selections',
                component: CrossesAndSelectionsComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.crosses-and-selections'
                }
            },
            {
                path: 'sample-genotype',
                component: SampleGenotypeComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.sample-genotype'
                }
            },
            {
                path: 'inventory',
                component: InventoryComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.inventory'
                }
            },
            {
                path: 'summary-statistics',
                component: SummaryStatisticsComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.summary-results'
                }
            },
            {
                path: 'sample-list/:listId',
                component: SampleListComponent,
                outlet: 'study-editor-outlet',
                data: {
                    pageTitle: 'study-editor.tabs.sample-list'
                }
            },
            {
                path: '',
                redirectTo: 'study-settings',
                pathMatch: 'full'
            }
        ]

    }
];
